import { useEffect, useState } from 'react'
import { IFrameContainer, IFrameBody, IFrameFooter, IFrameHeader } from './styled'
import Iframe from 'react-iframe'
import { getGuid } from 'shared/helpers/getGUID'
import { useBranchStore } from 'shared/store/branchesSlice'
import { useGlobalStore } from 'shared/store/globalSlice'

const QRMENU_URL = process.env.REACT_APP_QRMENU_URL
const CLICKCOLLECT_URL = process.env.REACT_APP_CLICKCOLLECT_URL
const GUID = '9712049C-1325-430F-B0C8-F6D64E5CF9C5'
const REGISTER = '24'

export const IFrameComponent = () => {
  const isCCSelected = useGlobalStore.getState().isCCSelected
  const branchList = useBranchStore().branchList
  const branchId = useBranchStore().branchId

  const clientId =
    branchList?.find(item => +item.Intern === branchId)?.QRMenuClientId ||
    branchList?.find(item => +item.Intern === branchId)?.ClickAndCollectClientId

  const [guid, setGuid] = useState('')
  const companyGUID = guid || GUID
  const registerID = clientId || REGISTER

  //
  const [isLoaded, setIsLoaded] = useState(false)
  const [windowWidth, setWindowWidth] = useState(1361)
  const [iFrameHeight, setIFrameHeight] = useState(844)
  //

  useEffect(() => {
    getAvailableHeight()
    getCompany()
  }, [])

  const getCompany = async () => {
    const company = await getGuid()
    setGuid(company || '')
  }

  const getAvailableHeight = () => {
    const totalHeight = window.screen.height
    setWindowWidth(document.body.clientWidth)
    setIFrameHeight(Math.min((totalHeight - 82 - 25 - 40 - 15 - 20) * 1.1, 844))
  }

  const currentUrl = isCCSelected
    ? `${CLICKCOLLECT_URL}/menu?guid=${companyGUID}&register=${registerID}`
    : `${QRMENU_URL}/menu?guid=${companyGUID}&register=${registerID}`

  return (
    <IFrameContainer>
      <IFrameHeader>Company preview</IFrameHeader>
      <IFrameBody>
        <Iframe
          // iframe styles are overwritten in index.css
          key={`iFrame_${currentUrl}_${windowWidth}`}
          url={currentUrl}
          // iPhone 12 Pro screen size
          width='390px'
          height={`${iFrameHeight}px`}
          id='Company preview'
          onLoad={() => setTimeout(() => setIsLoaded(true), 2500)}
          styles={{
            position: windowWidth > 1360 ? 'fixed' : 'relative',
            display: windowWidth > 1360 || isLoaded ? 'block' : 'none'
          }}
        />
      </IFrameBody>
      <IFrameFooter>Only filled fields will be displayed</IFrameFooter>
    </IFrameContainer>
  )
}
